import { hasInvalidCharsInAssetName, resetAssetNameIfDefault } from 'features/asset';
import { momentaryMessageDuration } from 'ui/config';
import { getQueryStringParameters } from 'utilities/browser';
import { roundNumber } from 'utilities/math';

const lp = window.lp || {};
lp.ar = lp.ar || {};
lp.ar.canvas = lp.ar.canvas || {};
lp.ar.priceType = {
	Retail: 0,
	Sale: 1,
	SpecialMember: 2,
	Clearance: 3,
	Professional: 4
};
lp.ar.maxCount = 9;
lp.ar.errorMessages = {
	General: 'An error occurred',
	CreateScene: 'There was an error creating your scene',
	UnspecifiedError: 'Unspecified Error',
	UserMaxScene: 'User Reached Max Scene limit',
	UnauthorizedAction: 'Unauthorized action - cannot perform operation',
	DuplicateSceneName: 'The room name you entered already exists',
	MaxAllowedSceneName: 'Scene name length exceeds max allowed length',
	SceneNotFound: 'The room you requested does not exist or is no longer available.',
	EmptyImageUrl: 'Background Image Url is empty',
	ImageNotFound: 'Provided image is not associated with user',
	EmployeeNotConnected: 'Employee is not connected as customer',
	EmptySceneName: 'Scene name cannot be empty',
	BackgroundImageIsInUse:
		'Background image is part of one or more scenes and deleting the background image would remove it from those scenes',
	Conflict: 'The room name you entered already exists',
	InvalidToken: 'Token supplied is Invalid',
	ImageDoesNotExist: 'Background image does not exist',
	SceneMaxAllowedProductLimitReached: `Oops, there is a limit of ${lp.ar.maxCount} items per room`,
	HasConcurrencyConflict: 'The current version of your scene is not up to date',
	MaxAllowedSceneNote: 'Scene note length exceeds max allowed length of 500.'
};

// global callback after save success for cases where model.save isn't called explicitly
lp.ar.processSuccess = (res) => {

	// set attributes such as spriteId, createdDate, isHidden on duplicate item
	lp.ar.canvas.setAttributesAfterDuplicate(res.Products);

};

lp.ar.processError = function (response, model) {

	const errorMessage = 'Error';
	let dismissError = false;
	lp.ar.saveQueue = 0;

	// No need to check for asset name conflict here, because it is being checked globally on every ajax response
	if (
		response.ErrorMessages
		&& response.ErrorMessages.length > 0
		&& response.ErrorMessages.indexOf('UnauthorizedAction') > -1
	) {

		$(lp.ar).trigger('UnauthorizedAction', [ { model } ]);

	} else if (response.InvalidSpritesData || response.ErrorMessages.indexOf('InvalidSpritesData') > -1) {

		$(lp.ar).triggerHandler('InvalidSpritesData');

	} else if (response.HasConcurrencyConflict || response.ErrorMessages.indexOf('HasConcurrencyConflict') > -1) {

		$(lp.ar).trigger('hasConcurrencyConflict');

	} else if (response.ErrorMessages.indexOf('UserMaxScene') > -1) {

		$(lp.ar).trigger('maxSceneReachedOnSave');

	} else if (response.ErrorMessages.indexOf('SceneMaxAllowedProductLimitReached') > -1) {

		$(lp.ar).trigger('limitReachedOnSave', [ model.get('Token') ]);

	} else if (response.ErrorMessages.indexOf('DuplicateSceneName') > -1) {

		$(lp.ar).trigger('showError', [ { message: lp.ar.errorMessages.DuplicateSceneName } ]);

	} else if (response.ErrorMessages.indexOf('MaxAllowedSceneName') > -1) {

		$(lp.ar).trigger('showError', [ { message: lp.ar.errorMessages.MaxAllowedSceneName } ]);

	} else if (response.ErrorMessages.indexOf('EmptySceneName') > -1) {

		$(lp.ar).trigger('showError', [ { message: lp.ar.errorMessages.EmptySceneName } ]);

	} else if (response.ErrorMessages.indexOf('SceneNotFound') > -1) {

		if (lp.ar.fetchingCurrent) {

			dismissError = true;
			$(lp.ar).trigger('emptyScene');

		} else {

			$(lp.ar).trigger('sceneNotFound', [ { message: lp.ar.errorMessages.SceneNotFound } ]);

		}

	} else if (response.ErrorMessages.indexOf('MaxAllowedSceneNote') > -1) {

		$(lp.ar).trigger('showNoteError', [ { message: lp.ar.errorMessages.MaxAllowedSceneNote } ]);

	}

	if (!dismissError) {

		$(lp.ar).trigger('messageAlert', { message: errorMessage, fast: false });

	}

};

lp.ar.initContentEditable = function ($arHeaderName, options, model) {

	const defaults = {
		maxLength: $arHeaderName.data('maxlength'),
		buttons: {
			submit: {
				label: 'Update',
				tagName: 'a'
			},
			cancel: {
				tagName: 'a'
			},
			divider: '|'
		},
		ajaxMethod: 'PUT',
		paramName: false,
		successMessage: '',
		editLinkText: 'edit',
		messageFadeOutTimer: momentaryMessageDuration,
		onInput (e) {

			// reset room name when it is system-generated
			resetAssetNameIfDefault($(this)[0]);

			// prevent invalid characters
			if (hasInvalidCharsInAssetName(e.which)) {

				return false;

			}

		},
		placeholder: /_/.test($arHeaderName.text()) ? $arHeaderName.text() : '', // set placeholder when name is system-generated
		highlightOnFocus: !/_/.test($arHeaderName.text()), // highlight name on focus when it is not system-generated
		showPlaceholder ($el, options) {

			// show placeholder text when name is system-generated
			if (/_/.test($el.text())) {

				$el.data('lpContentEditable').resetEditableElement($el);
				return true;

			}
			return false;

		},
		ajaxData: {},
		ajaxDataFilter (data, type) {

			let response;
			try {

				response = JSON.parse(data);

			} catch (e) {}

			if (response) {

				// normalize the ajax response to a new JSON object that contentEditable plugin expects
				if (response.IsSuccessful) {

					response = {
						success: true,
						text: response.Name,
						error: ''
					};
					model.set({ SceneName: $.trim($arHeaderName.text()) }, { silent: true });

				} else {

					// add to response fields that contentEditable plugin expects
					response.success = false;
					response.error = lp.ar.errorMessages[response.ErrorMessages[0]] || 'Saving failed.';

					// force asset prompt
					response.forceAssetPrompt = true;

					// dont need to call lp.ar.processError(response, model) here because asset-promt.js take care about this conflict

				}

			} else {

				response = {
					success: false,
					error: 'Saving failed.'
				};

			}

			return JSON.stringify(response);

		},
		onAjaxSuccess (response, textStatus, jqXHR) {

			const instanceOptions = $arHeaderName.data('lpContentEditable').options;
			instanceOptions.placeholder = ''; // reset placeholder since the editable element name is not system-generated anymore
			instanceOptions.highlightOnFocus = true; // enable highlighting of user-generated name when in edit mode

			if (typeof options.onAjaxSuccessCustom === 'function') {

				options.onAjaxSuccessCustom.call(this, response.text, response);

			}

		},
		onAjaxError (jqXHR, textStatus, errorThrown, responseError) {

			if (typeof options.onAjaxErrorCustom === 'function') {

				options.onAjaxErrorCustom.call(this, responseError || errorThrown); // responseError is the returned error message from a successful (HTTP 200) request

			}

		}
	};

	options = $.extend(true, {}, defaults, options);

	$arHeaderName.contentEditable(options);

};

lp.ar.showBackgroundModal = function (query, resize) {

	const path = `${lp.ar.path}/SceneView/background/${query || ''}`;
	const width = 480;
	const height = 320;

	if (resize) {

		$('body').lpModalResize({
			width,
			height
		});

		$('#lpModalContent').html(
			`<iframe width="100%" height="100%" src="${path}" scrolling="auto" horizontalscrolling="no" verticalscrolling="no" frameborder="0"></iframe>`
		);

	} else {

		lp.myScene.sceneViewBackgroundModal = $('body').lpModal({
			onInit: true,
			width,
			height,
			src: path,
			closeEvt () {

				Backbone.history.loadUrl();

			}
		});

	}

};

lp.ar.showManageScenes = function (query, resize) {

	const path = `${lp.ar.path}/ManageScenes/${query || ''}`;
	const width = 960;
	const height = 650;

	if (resize) {

		$('body').lpModalResize({
			width,
			height
		});

		$('#lpModalContent').html(
			`<iframe width="100%" height="100%" src="${path}" scrolling="auto" horizontalscrolling="no" verticalscrolling="no" frameborder="0"></iframe>`
		);

	} else {

		lp.myScene.manageScenesModal = $('body').lpModal({
			onInit: true,
			width,
			height,
			src: path,
			closeEvt () {

				// restore flag and try to save model when modal is closed
				lp.ar.skipLoad = false;

				Backbone.history.loadUrl();

			}
		});

	}

};

// Currently function is not called anywhere, iframe source inside function is separately being called on PDP
lp.ar.showAddScenes = function (query) {

	$('body').lpModal({
		onInit: true,
		width: 960,
		height: 650,
		src: `${lp.ar.path}/SceneView/scene/${query || ''}`,
		closeEvt () {

			Backbone.history.loadUrl();

		}
	});

};

/** Function that returns total number of product sprites in the scene, given the Products array * */
lp.ar.getTotalSprites = function (products) {

	let total = 0;

	if (products) {

		for (let i = 0; i < products.length; i++) {

			total += products[i].ProductSprites.length;

		}

	}

	return total;

};

lp.ar.calculateSpritePosition = (numberOfSprites, spriteIndex) => {

	let x = lp.ar.canvas.canvasW / 2;
	let y = lp.ar.canvas.canvasW / 2;

	switch (numberOfSprites) {

		case 1:
			break;
		case 2:
			x = (lp.ar.canvas.canvasW / 4) * (spriteIndex * 2 + 1);
			break;

		case 3:
			x = (lp.ar.canvas.canvasW / 6) * (spriteIndex * 2 + 1);
			y = (lp.ar.canvas.canvasW / 6) * (spriteIndex * 2 + 1);
			break;

		case 4:
			x = (lp.ar.canvas.canvasW / 4) * ((spriteIndex % 2) * 2 + 1);
			y = (lp.ar.canvas.canvasW / 4) * (Math.floor(spriteIndex / 2) * 2 + 1);
			break;

		default:
			// accounts for the other number of sprites from 5 to 9
			x = (lp.ar.canvas.canvasW / 6) * ((spriteIndex % 3) * 2 + 1);
			y = (lp.ar.canvas.canvasW / 6) * (Math.floor(spriteIndex / 3) * 2 + 1);
			break;

	}

	return { x, y };

};

lp.ar.loadSceneFromQuery = function (sceneModel, options = {}, callbackFn) {

	const urlParameters = getQueryStringParameters();
	const skus =		urlParameters.skus && !options?.ignoreSku ? urlParameters.skus.split(',').map((sku) => sku.toUpperCase()) : [];
	const isMoodBoard = window.parent.location.pathname.includes('viewer') && skus.length > 0;
	// if background token is set from start, we don't need to change it
	let backgroundToken = sceneModel.BackgroundImageToken || null;
	let backgroundName = sceneModel.BackgroundImageName || null;
	let sceneToken = urlParameters.sceneToken || null;
	let sceneName = '';
	let sprites = [];
	let versionNumber = 1;
	let lastAccessedDate = null;
	let successCallback = null;
	const imgHeight = sceneModel.ImageHeight;
	const imgWidth = sceneModel.ImageWidth;
	const errorCallback = function () {

		alert('An error occurred.');

	};
	const saveScene = function (model, success, error) {

		// set initial attributes to be saved
		const attrs = {
			ProductSprites: sprites,
			SceneName: sceneName,
			Token: sceneToken,
			VersionNumber: versionNumber,
			LastAccessedDate: lastAccessedDate,
			IsMoodBoard: isMoodBoard
		};

		// if passing background name, otherwise just pass the background token
		if (backgroundName) {

			attrs.BackgroundImageName = backgroundName;

		} else if (backgroundToken) {

			attrs.BackgroundImageToken = backgroundToken;

		}

		if (imgHeight) {

			attrs.ImageHeight = imgHeight;

		}

		if (imgWidth) {

			attrs.ImageWidth = imgWidth;

		}

		if (isMoodBoard) {

			attrs.BackgroundImageToken = window.lp.pageData.moodBoardBackgroundToken;

		}

		// load model with new attributes
		const thisModel = lp.ar.loadSceneModel(attrs);

		// remove all query strings
		window.history.replaceState({}, document.title, '/viewer');

		// save model
		model.save(thisModel, { success, error, silent: true });

	};
	const populateData = function () {

		if (sceneModel && sceneModel.attributes) {

			backgroundToken =				sceneModel.get('BackgroundImage') && backgroundToken == null
				? sceneModel.get('BackgroundImage').Token
				: backgroundToken;
			/** No need to get backgroundName here, AR model should never persist that info * */
			sceneToken = sceneModel.get('Token');
			sceneName = sceneModel.get('SceneName');
			sprites = $.map(sceneModel.get('Products'), (val, key) => val.ProductSprites);
			versionNumber = sceneModel.get('VersionNumber');
			lastAccessedDate = sceneModel.get('LastAccessedDate');

		} else if (sceneModel) {

			backgroundToken =				sceneModel.BackgroundImageToken && backgroundToken == null
				? sceneModel.BackgroundImageToken
				: backgroundToken;
			backgroundName =				sceneModel.BackgroundImageName && backgroundToken == null
				? sceneModel.BackgroundImageName
				: backgroundName;
			sceneToken = sceneModel.Token || '';
			sceneName = sceneModel.SceneName || '';
			sprites = sceneModel.ProductSprites || [];
			versionNumber = sceneModel.VersionNumber || null;
			lastAccessedDate = sceneModel.LastAccessedDate || null;

			// make sure to create an actual model so that we can save
			// eslint-disable-next-line no-param-reassign
			sceneModel = new lp.ar.SceneModel();

		}

		if (skus.length) {

			// number of skus cannot be past max product count
			if (skus.length > lp.ar.maxCount) skus.length = lp.ar.maxCount;

			const skusLength = skus.length;

			for (let i = 0; i < skusLength; i++) {

				const pos = lp.ar.calculateSpritePosition(skusLength, i);

				// if adding from product detail page or to mood board
				sprites.push({
					OriginX: pos.x,
					OriginY: pos.y,
					Height: lp.ar.canvas.defaultSize,
					Width: lp.ar.canvas.defaultSize,
					RotationalDegree: 0,
					Layer: sprites.length + 2,
					ShortSku: skus[i],
					Scale: 1,
					IsHidden: false,
					IsFlipped: false
				});

			}

		}

		if (window.lp.pageData.isRooms) {

			window.location.href = lp.ar.path;

		} else {

			if (window.parent.lp.ar) {

				// if creating or opening a new scene from ar page
				successCallback = function (data) {

					window.parent.$('body').lpModalClose();
					window.parent.lp.utils.getAssetCounts();

					if (typeof callbackFn === 'function') callbackFn();

				};

			} else {

				successCallback = function (data) {

					// Coming from product detail page
					window.parent.window.location.href = lp.ar.path;

					if (typeof callbackFn === 'function') callbackFn();

				};

			}

			saveScene(sceneModel, successCallback, errorCallback);

		}

	};

	populateData();

};

lp.ar.loadSceneModel = function (model, options) {

	let backgroundToken;
	let backgroundName;
	let sceneToken;
	let sceneName;
	let sprites;
	let versionNumber;
	let lastAccessedDate;
	let isOwnerOfAsset;
	let imgHeight;
	let imgWidth;
	let isMoodBoard;
	let note;

	if (model.attributes) {

		backgroundToken = model.get('BackgroundImage') ? model.get('BackgroundImage').Token : null;
		/** No need to get backgroundName here, AR model should never persist that info * */
		sceneToken = model.get('Token') || null;
		sceneName = model.get('SceneName') || null;
		sprites = $.map(model.get('Products'), (val) => val.ProductSprites);
		versionNumber = model.get('VersionNumber') || null;
		lastAccessedDate = model.get('LastAccessedDate') || null;
		isOwnerOfAsset = model.get('IsOwnerOfAsset') || null;
		isMoodBoard = model.get('IsMoodBoard') || null;
		note = model.get('Note') || '';

		// specify options if you want to overwrite the current model attributes
		if (options) {

			backgroundToken = options.BackgroundImageToken || backgroundToken;
			backgroundName = options.BackgroundImageName || backgroundName;
			sceneToken = options.Token || options.Token === '' ? options.Token : sceneToken;
			sceneName = options.sceneName === '' || options.sceneName ? options.sceneName : sceneName;
			sprites = options.ProductSprites || sprites;
			isOwnerOfAsset = options.IsOwnerOfAsset || isOwnerOfAsset;
			imgHeight = options.ImageHeight || imgHeight;
			imgWidth = options.ImageWidth || imgWidth;
			isMoodBoard = options.IsMoodBoard || isMoodBoard;
			note = options.Note || note;

		}

	} else {

		backgroundToken = model.BackgroundImageToken;
		backgroundName = model.BackgroundImageName;
		sceneToken = model.Token;
		sceneName = model.SceneName;
		sprites = model.ProductSprites;
		versionNumber = model.VersionNumber || null;
		lastAccessedDate = model.LastAccessedDate || null;
		isOwnerOfAsset = model.IsOwnerOfAsset || null;
		imgHeight = model.ImageHeight || imgHeight;
		imgWidth = model.ImageWidth || imgWidth;
		isMoodBoard = model.IsMoodBoard || isMoodBoard;
		note = model.Note || '';

	}

	const obj = {
		SceneName: sceneName,
		ProductSprites: sprites,
		Token: sceneToken,
		Note: note
	};

	if (imgHeight) {

		obj.ImageHeight = imgHeight;

	}
	if (imgWidth) {

		obj.ImageWidth = imgWidth;

	}

	// if passing background name, otherwise just pass the background token
	if (backgroundName) {

		obj.BackgroundImageName = backgroundName;

	} else if (backgroundToken) {

		obj.BackgroundImageToken = backgroundToken;

	}

	if (versionNumber) {

		obj.VersionNumber = versionNumber;

	}

	if (lastAccessedDate) {

		obj.LastAccessedDate = lastAccessedDate;

	}

	// must pass this for when duplicating a scene
	if (isOwnerOfAsset) {

		obj.IsOwnerOfAsset = true;

	}

	if (isMoodBoard) {

		obj.IsMoodBoard = true;

	}

	return obj;

};

const augmentedReality = function () {

	let handleSize = 10;

	if (window.isIpad()) {

		handleSize = 20;

	}

	// set private variables
	const that = this;
	let paper = null;
	let count = 0;
	let prevEl = 0;
	let currEl = 0;
	let maxZ = 1;
	const options = {
		// options to render an element with a transform tool
		attrs: { fill: 'black', stroke: 'black' },
		draw: [ null, 'circle' ],
		distance: 1.5,
		drag: 'self',
		keepRatio: [ 'axisX', 'axisY', 'bboxCorners', 'bboxSides' ],
		range: { rotate: [ -180, 360 ], scale: [ 35, 99999 ] },
		rotate: true,
		scale: true,
		size: handleSize,
		snap: { drag: 0, rotate: 0, scale: 0 },
		snapDist: { drag: 7, rotate: 5, scale: 10 }
	};
	const optionsNoTransform = {
		// options to render without transform tool (ex. background)
		draw: false,
		drag: 'self',
		rotate: false,
		scale: false
	};

	// set global variables
	this.background = null;
	this.images = [];
	this.canvasW = 690;
	this.canvasH = 690;
	this.defaultSize = 200;

	this.resetCanvas = function () {

		paper.clear();
		this.background = null;
		this.images = [];
		count = 0;
		prevEl = 0;
		currEl = 0;
		maxZ = 1;

	};

	this.selectElement = function (id) {

		prevEl = currEl;
		currEl = id;

		const prevImage = this.images.find((e) => e.id === prevEl);
		const currImage = this.images.find((e) => e.id === currEl);

		if (prevImage) {

			prevImage.freeTransform.setOpts(optionsNoTransform, false);

		}

		if (currImage) {

			if (!currImage.isHidden) {

				currImage.freeTransform.setOpts(options, false);

			}

			$(lp.ar).trigger('spriteSelected', [ that.getOptions() ]);

		} else {

			$(lp.ar).trigger('spriteSelected');

		}

	};

	this.setAttributesAfterDuplicate = (products) => {

		const duplicated = this.images.filter((i) => i.tempIndex !== undefined);

		// nothing was duplicated
		if (duplicated.length === 0) {

			return;

		}

		for (let i = 0; i < duplicated.length; i++) {

			const el = duplicated[i];
			const sku = el.shortSku;
			const product = products.filter((p) => p.ShortSku === sku)[0];
			const sprite = product.ProductSprites[el.tempIndex];

			el.spriteId = sprite.Id;
			el.isHidden = sprite.IsHidden;
			el.IsFlipped = sprite.IsFlipped;
			el.createdDate = sprite.CreatedDate;
			el.tempIndex = undefined;

		}

		$(lp.ar).trigger('setDuplicate');

	};

	this.getSelected = function () {

		const elements = this.images.map((e) => e.freeTransform.circle);

		for (let i = 0; i < elements.length; i += 1) {

			if (elements[i]) {

				return { element: that.images[i], index: i };

			}

		}

		return false;

	};

	this.getSelectedBySpriteId = function (spriteId) {

		return this.images.find((e) => e.spriteId === spriteId);

	};

	this.getOptions = function (id) {

		// options for displaying whether controls are active or not
		const opts = {
			forward: true,
			back: true,
			del: true,
			duplicate: true,
			deselect: true,
			hide: false,
			flipHorizontally: true
		};
		let index;
		let sprite;

		if (id) {

			index = this.images.map((e) => e.id).indexOf(id);
			sprite = this.images[index];

		} else {

			const el = this.getSelected();

			if (el === false) {

				return false;

			}

			index = el.index;
			sprite = el.element;

		}

		const handle = sprite.freeTransform;
		opts.id = index;
		opts.image = sprite.attrs.src;

		// check to see if sprite has z layer of 1
		if (sprite.zLayer === 1) {

			opts.back = false;

		}

		// check to see if sprite has z layer max
		if (sprite.zLayer === maxZ) {

			opts.forward = false;

		}

		opts.hide = !sprite.isHidden;

		return opts;

	};

	this.updateIsHiddenState = function ({
		spriteId, isHidden, model, skipRenderFooter
	}) {

		const products = model.get('Products');
		let found = false; // Linter restricts loop label, so let's use a flag

		for (let i = 0; i < products.length; i += 1) {

			const product = products[i];
			const productSprites = product.ProductSprites;

			for (let j = 0; j < productSprites.length; j += 1) {

				if (productSprites[j].Id === spriteId) {

					products[i].ProductSprites[j].IsHidden = isHidden;
					found = true;
					break;

				}

			}

			if (found) {

				break;

			}

		}

		model.set('Products', products);

		$(lp.ar).trigger('sceneChange', [ skipRenderFooter ]);

	};

	this.hideElementOnCanvas = function (element, model) {

		if (!model || !element) {

			return false;

		}

		const products = model.get('Products');

		for (let i = 0; i < products.length; i += 1) {

			const product = products[i];
			const productSprites = product.ProductSprites;

			for (let j = 0; j < productSprites.length; j += 1) {

				if (productSprites[j].IsHidden && productSprites[j].Id === element.spriteId) {

					element.hide();
					// eslint-disable-next-line no-param-reassign
					element.isHidden = true;
					return true;

				}

			}

		}

		return false;

	};

	this.sortProductSpritesByLayer = function (products) {

		if (!products || products.length === 0) {

			return [];

		}

		const unsortedProducts = [];

		// render products
		products.forEach((product) => {

			const spriteUrl = product.SpriteUrl;
			const shortSku = product.ShortSku;

			product.ProductSprites.forEach((spriteData) => {

				const spriteFlipUrl = spriteData.IsFlipped ? `${spriteUrl}&flip=lr` : spriteUrl.replace('&flip=lr', '');
				const sprite = {
					x: spriteData.OriginX,
					y: spriteData.OriginY,
					width: spriteData.Width,
					height: spriteData.Height,
					imagePath: `${spriteFlipUrl}&wid=${spriteData.Width}&hei=${spriteData.Height}`,
					rotate: spriteData.RotationalDegree,
					zLayer: spriteData.Layer - 1,
					sku: shortSku,
					spriteId: spriteData.Id,
					isHidden: spriteData.IsHidden,
					IsFlipped: spriteData.IsFlipped,
					createdDate: spriteData.CreatedDate
				};

				unsortedProducts.push(sprite);

			});

		});

		// We must sort products by z index and add them in that order
		return _.sortBy(unsortedProducts, 'zLayer');

	};

	this.calcDuplicatePosition = function (sku) {

		const offset = 30;
		const posThreshold = 10;
		const scaleThreshold = 0.05;
		const rotThreshold = 5.4;
		let x = this.canvasW / 2 - offset;
		let y = this.canvasH / 2 + offset;
		const search = function () {

			let found = false;

			x += offset;
			y -= offset;

			for (let i = 0; i < that.images.length; i++) {

				const obj = that.images[i].freeTransform.attrs;

				if (
					obj.translate.x + obj.center.x <= x + posThreshold
					&& obj.translate.x + obj.center.x >= x - posThreshold
					&& obj.translate.y + obj.center.y <= y + posThreshold
					&& obj.translate.y + obj.center.y >= y - posThreshold
					&& that.images[i].shortSku === sku
					&& obj.rotate <= rotThreshold
					&& obj.rotate >= 0 - rotThreshold
					&& obj.scale.x <= 1 + scaleThreshold
					&& obj.scale.x >= 1 - scaleThreshold
				) {

					found = true;
					break;

				}

			}

			// if a sprite is located in same position, then repeat search again with new coordinates
			if (found) {

				search();

			}

		};

		search();

		return { x, y };

	};

	this.duplicate = function (callbackFn) {

		const el = this.getSelected().element;
		const coords = this.calcDuplicatePosition(el.shortSku);
		const obj = {
			x: coords.x,
			y: coords.y,
			width: this.defaultSize,
			height: this.defaultSize,
			imagePath: el.attrs.src,
			rotate: 0,
			zLayer: el.zLayer,
			sku: el.shortSku,
			tempIndex: this.images.filter((i) => i.shortSku === el.shortSku).length
		};

		this.add(obj);

		if (typeof callbackFn === 'function') {

			callbackFn({
				sku: obj.sku
			});

		}

	};

	this.add = function (obj, isBackground, model) {

		const {
			imagePath, rotate, sku, x, y, spriteId, isHidden, createdDate, tempIndex, IsFlipped
		} = obj;
		let { height, width } = obj;

		if (isBackground) {

			// if bg elment exists, remove it before adding another one
			if (this.background != null) {

				this.removeElement({ isBackground: true });

			}

			this.background = paper.image(imagePath, x, y, width, height);
			this.background.id = 99999; // background index is always 99999
			this.background.toBack();

			if (window.isIpad()) {

				this.background.touchend(() => {

					lp.ar.canvas.spriteSelected = false;

					if (that.images.length && that.images[currEl]) {

						// if images exist, hide the handles of currently selected image.
						that.images[currEl].freeTransform.hideHandles({ undrag: false });

					}

				});

			} else {

				this.background.mousedown(() => {

					lp.ar.canvas.spriteSelected = false;

					if (that.images.length && that.images[currEl]) {

						// if images exist, hide the handles of currently selected image.
						that.images[currEl].freeTransform.hideHandles({ undrag: false });

					}

				});

			}

			if (this.images.length && this.images[currEl]) {

				// if images exist, hide the handles of currently selected image on background load
				this.images[currEl].freeTransform.hideHandles({ undrag: false });

			}

			// if background loads after all sprites are loaded, then this must be called to select the current sprite
			this.selectElement(currEl);

		} else {

			// cannot have more objects added to scene
			if (this.images.length >= lp.ar.maxCount) {

				$(lp.ar).trigger('limitReached', [ sku ]);

			} else {

				const element = paper.image(imagePath, 0, 0, this.defaultSize, this.defaultSize); // pass in default sizes as width and height to set the base for scaling later on
				const ft = paper.freeTransform(element, options, false);

				// set id for each image
				element.id = count++;

				// add image to global array
				this.images.push(element);

				// position element correctly on canvas
				this.transformEl({
					handle: ft,
					x,
					y,
					scale: 1,
					rotate,
					silent: true
				});

				// if height and width are 0, then set it to default
				if (height === 0) {

					height = this.defaultSize;
					width = this.defaultSize;

				}

				this.transformEl({ handle: ft, scale: height / ft.attrs.size.y });

				if (window.isIpad()) {

					element.touchend(() => {

						lp.ar.canvas.spriteSelected = true;
						that.selectElement(element.id);

					});

				} else {

					element.mouseup(() => {

						lp.ar.canvas.spriteSelected = true;
						that.selectElement(element.id);

					});

				}

				// for each image added, we need to increase the max z index, starting with 2nd one.
				if (this.images.length > 1) {

					maxZ++;

				}

				// set z index for each image, which should be the same value as z
				element.zLayer = maxZ;

				element.shortSku = sku;
				element.spriteId = spriteId;
				element.isHidden = isHidden;
				element.IsFlipped = IsFlipped || false;
				element.createdDate = createdDate;

				if (tempIndex !== undefined) {

					element.tempIndex = tempIndex;

				}

				// display handles upon adding
				this.selectElement(element.id);

				this.hideElementOnCanvas(element, model);

			}

		}

	};

	this.renderScene = function (model) {

		const canvasWidth = 690;
		const canvasHeight = 690;

		// resets entire canvas
		this.resetCanvas();

		if (lp.ar.saveQueue === 0 || lp.ar.saveQueue === undefined) {

			lp.ar.saveQueue = 0;
			$(lp.ar).trigger('messageAlert', { message: 'All changes auto saved', fast: false });

		}

		if (model != null) {

			const products = model.get('Products');
			const backgroundImage = model.get('BackgroundImage');

			$(lp.ar).trigger('spriteSelected'); // trigger this to reset controls

			// render background image if it exists
			if (backgroundImage != null) {

				const img = new Image();
				const bgImageUrl = `${backgroundImage.ImageUrl}&wid=${canvasWidth}&hei=${canvasHeight}`;
				img.onload = function () {

					const obj = {
						x: 0,
						y: 0,
						width: img.width,
						height: img.height,
						imagePath: bgImageUrl,
						rotate: 0,
						zLayer: 0,
						sku: ''
					};

					that.add(obj, true);

				};

				img.src = bgImageUrl;

			}

			const sortedProducts = this.sortProductSpritesByLayer(products);
			sortedProducts.forEach((product) => this.add(product, false, model));

			const selectedVisibleImage = this.images.find((image) => !image.isHidden && image.freeTransform.circle);
			if (!selectedVisibleImage) {

				const firstVisibleElement = this.images.find((image) => !image.isHidden);
				if (firstVisibleElement) {

					this.selectElement(firstVisibleElement.id);

				}

			}

		}

	};

	this.startScene = function (model) {

		const setWidth = 690;
		const setHeight = 690;

		$('svg').remove(); // in case another svg is in DOM

		paper = Raphael('arCanvas');

		// Setting preserveAspectRatio to 'none' lets you stretch the SVG
		paper.canvas.setAttribute('preserveAspectRatio', 'none');

		paper.canvas.setAttribute('title', 'View In Room');

		// Set svg width and height manually through DOM
		$('svg').attr('height', setHeight).attr('width', setWidth);

		// Render scene
		this.renderScene(model);

	};

	this.setSprites = function () {

		const sprites = [];

		for (let i = 0; i < this.images.length; i++) {

			const image = that.images[i];
			const obj = image.freeTransform.attrs;
			const attrs = {
				Id: image.spriteId,
				OriginX: obj.translate.x + obj.center.x,
				OriginY: obj.translate.y + obj.center.x,
				Height: Math.round(obj.scale.y * obj.size.y),
				Width: Math.round(obj.scale.x * obj.size.x),
				RotationalDegree: roundNumber(obj.rotate, 8), // set max decimal places to 8, because there is a max in database as well
				Layer: image.zLayer + 1,
				ShortSku: image.shortSku,
				Scale: 1,
				IsHidden: image.isHidden,
				CreatedDate: image.createdDate,
				IsFlipped: image.IsFlipped
			};

			// Refresh sprite url in case image was resized
			that.images[i].node.href.baseVal = `${image.attrs.src.split('&wid=')[0]}&wid=${attrs.Width}&hei=${
				attrs.Height
			}`;

			if (attrs.Width != that.defaultSize && attrs.Height != that.defaultSize) {

				that.images[i].scaleSize = true;

			} else {

				that.images[i].scaleSize = false;

			}

			sprites.push(attrs);

		}

		return sprites;

	};

	this.removeElement = function (options, callbackFn) {

		if (options && options.isBackground) {

			this.background.remove();
			if (this.background.freeTransform) {

				this.background.freeTransform.unplug();

			}

			return 'background';

		}

		let element = null;
		let index = null;

		if (options && options.element) {

			element = options.element;
			index = 'true';

		} else {

			const el = this.getSelected();

			element = el.element;
			index = el.index;

		}

		const { id } = element;
		const z = element.zLayer;

		if (typeof callbackFn === 'function') {

			const sku = element.shortSku || '';
			callbackFn({
				sku
			});

		}

		element.freeTransform.unplug();
		element.remove();
		element.id = id;
		element.zLayer = z;
		this.popZ(id);

		return index; // returns the index of element that was removed

	};

	this.popZ = function (id) {

		const index = this.images.map((e) => e.id).indexOf(id);

		if (this.images[index]) {

			for (let i = 0; i < this.images.length; i++) {

				if (that.images[i].zLayer > that.images[index].zLayer) {

					that.images[i].zLayer--;

				}

			}
			maxZ--;
			that.images.splice(index, 1);

		}

	};

	this.moveFront = function (element, callbackFn) {

		element.toFront();

		for (let i = 0; i < this.images.length; i++) {

			if (that.images[i].zLayer != null && that.images[i].zLayer > element.zLayer) {

				that.images[i].zLayer--;

			}

		}
		element.zLayer = maxZ;

		if (typeof callbackFn === 'function') {

			const sku = element.shortSku || '';
			callbackFn({
				sku
			});

		}

	};

	this.moveBack = function (element) {

		element.toBack();

		for (let i = 0; i < this.images.length; i++) {

			if (that.images[i].zLayer != null && that.images[i].zLayer < element.zLayer) {

				that.images[i].zLayer++;

			}

		}
		element.zLayer = 1;

	};
	this.updateFlipState = function ({ spriteId, isFlipped, model }) {

		const products = model.get('Products');
		let found = false;
		for (let i = 0; i < products.length; i += 1) {

			const product = products[i];
			const productSprites = product.ProductSprites;

			for (let j = 0; j < productSprites.length; j += 1) {

				if (productSprites[j].Id === spriteId) {

					products[i].ProductSprites[j].IsFlipped = isFlipped;
					found = true;
					break;

				}

			}

			if (found) {

				break;

			}

		}
		model.set('Products', products);
		$(lp.ar).trigger('sceneChange');
		this.renderScene(model);
		const selectedElement = lp.ar.canvas.getSelectedBySpriteId(spriteId);
		lp.ar.canvas.selectElement(selectedElement.id);

	};
	this.moveUp = function (options, callbackFn) {

		let element = null;

		if (options && options.element != null) {

			element = options.element;

		} else {

			const el = this.getSelected();
			element = el.element;

		}

		// if element is not background
		if (element.id != 99999) {

			const currentZ = element.zLayer; // the z-index of current element.

			// checks to make sure if element is not already on top and it's not a BG
			if (currentZ < maxZ) {

				this.moveFront(element);

				for (let i = currentZ + 1; i < maxZ; i++) {

					const nextZ = currentZ + 1;
					const nextIndex = that.images.map((e) => e.zLayer).indexOf(nextZ);
					const nextEl = that.images[nextIndex];

					that.moveFront(nextEl);

				}

			}

			$(lp.ar).trigger('canvasChange');

		}

		if (typeof callbackFn === 'function') {

			const sku = element.shortSku || '';
			callbackFn({
				sku
			});

		}

	};

	this.moveDown = function (options, callbackFn) {

		let element = null;

		if (options && options.element != null) {

			element = options.element;

		} else {

			const el = this.getSelected();
			element = el.element;

		}

		// if element is not background
		if (element.id != 99999) {

			const currentZ = element.zLayer; // the z-index of current element.

			// checks to make sure if element is not already on bottom
			if (currentZ != 1) {

				this.moveBack(element);

				for (let i = currentZ - 1; i > 1; i--) {

					const prevZ = currentZ - 1;
					const prevIndex = that.images.map((e) => e.zLayer).indexOf(prevZ);
					const prevEl = that.images[prevIndex];

					that.moveBack(prevEl);

				}

			}

			if (that.background != null) {

				that.background.toBack();

			}

			$(lp.ar).trigger('canvasChange');

		}

		if (typeof callbackFn === 'function') {

			const sku = element.shortSku || '';
			callbackFn({
				sku
			});

		}

	};

	this.hideElement = function (options, callbackFn) {

		let element = null;

		if (options && options.element != null) {

			element = options.element;

		} else {

			const el = this.getSelected();
			element = el.element;

		}

		if (!element) {

			return;

		}

		element.hide();
		element.isHidden = true;
		element.freeTransform.hideHandles({ undrag: false });

		if (typeof callbackFn === 'function') {

			const sku = element.shortSku || '';
			const { spriteId } = element;
			callbackFn({
				sku,
				spriteId
			});

		}

	};

	this.transformEl = function (options) {

		if (options && options.handle) {

			if (options.rotate != null) {

				options.handle.attrs.rotate = options.rotate;

			}
			if (options.scale != null) {

				options.handle.attrs.scale.x = options.scale;
				options.handle.attrs.scale.y = options.scale;

			}
			if (options.x != null) {

				options.handle.attrs.translate.x = options.x - options.handle.attrs.center.x;

			}
			if (options.y != null) {

				options.handle.attrs.translate.y = options.y - options.handle.attrs.center.y;

			}

			options.handle.apply();

			if (options.silent != true) {

				this.setSprites(); // update sprites

			}

		}

	};

};

augmentedReality.call(lp.ar.canvas);
